import React, {useEffect, useRef, useState} from "react";
import {ReportApiCalls} from "../../apis/ReportApiCalls";
import classes from "./Report.module.css"
import {YuJaTextBox} from "../../components/standardization/YuJaTextBox";
import { ReactComponent as SearchIcon } from "../../images/search_bar_icon.svg";
import {BUTTON, REPORT_DATE_FILTER_LABEL} from "../../utils/constants";
import {MonthPicker} from "./MonthPicker";
import {getYearMonthStr} from "./ReportHelper";
import { ReactComponent as ARROW_RIGHT } from "../../images/arrow_right.svg";
import { ReactComponent as NO_RESULT } from "../../images/no_result.svg";
import {ReactComponent as BACK} from "../../images/arrow-left-purple.svg"
import {ReactComponent as SHARE} from "../../images/share-thin.svg"
import {ReactComponent as DOWNLOAD} from "../../images/download.svg"
import {ReactComponent as CLOSE} from "../../images/Close.svg"
import YuJaButton from "../../components/standardization/YuJaButton";
import useWindowDimensions from "../../hooks/useWindowDimensions";

import Skeleton from "react-loading-skeleton";
import html2pdf from 'html2pdf.js';
import ShareUsageReportModal from "../../components/modals/ShareUsageReportModal";
import DOMPurify from 'dompurify';


export default function ReportUsagePage(props) {
    const {listMonthUsageReports, getMonthlyUsage} = ReportApiCalls();
    const windowDimensions = useWindowDimensions();
    const {width} = windowDimensions;

    const [reportStartDate, setReportStartDate] = useState(() => {
        let currentDate = new Date();
        currentDate.setDate(1);
        currentDate.setMonth(currentDate.getMonth() - 6);
        return getYearMonthStr(currentDate);
    });

    const [reportEndDate, setReportEndDate] = useState(() =>{
        let currentDate = new Date();
        currentDate.setDate(1);
        return getYearMonthStr(currentDate);
    });

    const [curDate, ] = useState(() =>{
        let currentDate = new Date();
        currentDate.setDate(1);
        return getYearMonthStr(currentDate);
    });

    const [reportData, setReportData] = useState([]);
    const [rawData, setRawData] = useState([]);
    const [keyword, setKeyword] = useState("");
    const [monthlyUsageHtml, setMonthlyUsageHtml] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const [isProgressing, setIsProgressing] = useState(false);
    const [isListing, setIsListing] = useState(true);
    const [isModalShown, setIsModalShown] = useState(false);
    const [selectedYearMonth, setSelectedYearMonth] = useState("");

    const pdfBlobCur = useRef();


    useEffect(() => {
        listMonthUsageReports(reportStartDate, reportEndDate).then(res => {
            setReportData(res);
            setRawData(res);
        }).finally(() => {
            setIsListing(false);
        });
    }, [reportStartDate, reportEndDate]);

    useEffect(() => {
        props.setPageIdentifier("Usage Report");
    }, []);

    useEffect(() => {
        if (!keyword) {
            setReportData(rawData);
        } else {
            setReportData(rawData.filter(data => {
                let yearMonth = data.title.split("-")[0].toLowerCase();
                return yearMonth.indexOf(keyword.toLowerCase()) !== -1;
            }));
        }


    }, [rawData, keyword]);


    useEffect(() => {
        const targetDiv = document.getElementById("highlightUsageTarget");
        if(!isOpen || !!isProgressing || !monthlyUsageHtml || !targetDiv) {
            return;
        }

        targetDiv.innerHTML = DOMPurify.sanitize(monthlyUsageHtml, {
            FORCE_BODY: true,
        });

        const el = targetDiv.querySelector('[style*="margin:0px auto"][style*="max-width:900px"]');
        if (!!el) {
            el.style.maxWidth = `${Math.min(0.9 * width, 900) - 200}px`;
        }

        targetDiv.querySelectorAll("tbody td").forEach(el => {
            el.style.setProperty("background-color", "transparent", "important");
        });

        targetDiv.querySelectorAll("div.border").forEach(el => {
            el.style.overflow = "hidden";
        });

        targetDiv.querySelectorAll('[style*="line-height:1"]').forEach(el => {
            el.style.lineHeight = "1.4";
        });
    }, [isOpen, isProgressing, monthlyUsageHtml]);

    const openReport = (yearMonth) => {
        setIsOpen(true);
        setIsProgressing(true);
        // yearMonthCur.current = yearMonth;
        setSelectedYearMonth(yearMonth);
        getMonthlyUsage(yearMonth).then(async (htmlString) => {
            setMonthlyUsageHtml(htmlString);
            await convertPDF(htmlString);
        }).finally(() => {
            setIsProgressing(false);
        })
    }

    const convertPDF = async (htmlString) => {
        const tempContainer = document.createElement('div');
        tempContainer.style.display = 'none'; // Hide the container completely
        tempContainer.innerHTML = DOMPurify.sanitize(htmlString, {
            FORCE_BODY: true,
        });

        // Append the container to the body so it's part of the live document for queries
        document.body.appendChild(tempContainer);

        const el = tempContainer.querySelector('[style*="margin:0px auto"][style*="max-width:900px"]');
        if (el) {
            el.style.maxWidth = `${Math.min(0.9 * width, 900) - 200}px`;
        }

        tempContainer.querySelectorAll("tbody td").forEach(td => {
            td.style.setProperty("background-color", "transparent", "important");
        });

        tempContainer.querySelectorAll("div.border").forEach(div => {
            div.style.overflow = "hidden";
        });

        tempContainer.querySelectorAll('[style*="line-height:1"]').forEach(el => {
            el.style.lineHeight = "1.4";
        });

        tempContainer.querySelectorAll('.metric-card-block').forEach(el => {
            el.style.pageBreakInside = "avoid";
        });

        // let element = tempContainer.querySelector("img[alt='Banner Image']");
        // element.src = "https://staging-verity-report-email.s3.us-east-2.amazonaws.com/title.png";

        let finalHtmlString = tempContainer.outerHTML;
        const openTag = '<div style="display: none;">';
        const closeTag = '</div>';
        // A. Check and replace the opening tag
        if (finalHtmlString.startsWith(openTag)) {
            // Replace the opening tag with the desired <html><body> structure
            finalHtmlString = '<html><body>' + finalHtmlString.slice(openTag.length);
        } else {
            console.warn("Could not find expected opening tag for replacement.");
        }

        // B. Check and replace the closing tag
        if (finalHtmlString.endsWith(closeTag)) {
            // Remove the closing tag and append the desired </body></html> structure
            finalHtmlString = finalHtmlString.slice(0, finalHtmlString.length - closeTag.length) + '</body></html>';
        } else {
            console.warn("Could not find expected closing tag for replacement.");
        }
        document.body.removeChild(tempContainer);

        const pdfBlob = await html2pdf().set({
            margin: 10,
            filename: `EngageUsageReport.pdf`,
            image: { type: 'jpeg', quality: 1 },
            html2canvas: { scale: 2, useCORS: true },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
            pagebreak: {
                mode: '',
                avoid: '.metric-card-block'
            }
        }).from(finalHtmlString).output('blob');

        pdfBlobCur.current = pdfBlob;

    }

    const onDownload = () => {
        if (!!pdfBlobCur.current) {
            let year = selectedYearMonth.split("-")[0];
            let month = selectedYearMonth.split("-")[1];
            // Create a temporary URL for the Blob
            const url = URL.createObjectURL(pdfBlobCur.current);

            // Create a temporary link element
            const a = document.createElement('a');
            a.href = url;
            a.download = `EngageUsageReport_${month}_${year}.pdf`;

            // Programmatically click the link to trigger download
            document.body.appendChild(a);
            a.click();

            // Clean up the temporary URL and element
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        }
    }


    useEffect(() => {
        const handleKeyDownDropdown = (event) => {
            if (event.key !== "Tab") {
                return;
            }
            const container = document.querySelector("#usageReportDetailContainer");
            if (!container) {
                return;
            }

            const focusableElements = container.querySelectorAll('[tabindex]:not([tabindex="-1"]), input');

            if (!container.contains(event.target)) {
                event.preventDefault();
                focusableElements[0].focus();
                return;
            }

            if (event.shiftKey) {
                for (let i = 0; i < focusableElements.length; i++) {
                    if (focusableElements[i] !== event.target) {
                        continue;
                    }
                    if (i === 0) {
                        event.preventDefault();
                        focusableElements[focusableElements.length - 1].focus();
                        return;
                    } else {
                        event.preventDefault();
                        focusableElements[i - 1].focus();
                        return;
                    }
                }
            } else {
                for (let i = 0; i < focusableElements.length; i++) {
                    if (focusableElements[i] !== event.target) {
                        continue;
                    }
                    if (i === focusableElements.length - 1) {
                        event.preventDefault();
                        focusableElements[0].focus();
                        return;
                    } else {
                        event.preventDefault();
                        focusableElements[i + 1].focus();
                        return;
                    }
                }
            }

        };

        if (!!isOpen) {
            document.addEventListener("keydown", handleKeyDownDropdown);
        }


        return () => {
            document.removeEventListener("keydown", handleKeyDownDropdown);
        };
    }, [isOpen]);

    return (
        <div className={classes.parentContainer} style={{height: "100%"}}>
            <ShareUsageReportModal setModalShow={setIsModalShown} show={isModalShown} yearMonth={selectedYearMonth}/>
            <div className={classes.usageCard}>
                <h2 className={classes.title}>Engage's Monthly Usage Reports</h2>
                <div style={{height: 20}}/>
                <div className={classes.filterCard}>
                    <YuJaTextBox
                        containerStyle={{fontSize: 14, lineHeight: 1.6, flex: 1, height: 35, minWidth: 200}}
                        onChange={e => setKeyword(e.target.value)}
                        value={keyword}
                        before={<SearchIcon style={{marginRight: 5, width: 16}}/>}
                        after={
                            !!keyword
                                ? (
                                    <div
                                        tabIndex={0}
                                        role={BUTTON}
                                        aria-label={"Clear search keyword"}
                                        className={classes.closeIcon}
                                        onClick={() => setKeyword("")}
                                    >
                                        <CLOSE style={{width: 16, height: 16}}/>
                                    </div>
                                )
                                : (<></>)
                        }
                        placeholder={"Search by month and year"}
                    />

                    <div style={{width: 20}}/>

                    <div className={classes.filterController}>
                        <span className={classes.regularLabel} style={{marginRight: 5}}>{REPORT_DATE_FILTER_LABEL}</span>
                        <MonthPicker dateStr={reportStartDate} setDateStr={setReportStartDate}
                                     maxDateStr={reportEndDate}/>
                        <ARROW_RIGHT style={{marginLeft: 5, marginRight: 5}}/>
                        <MonthPicker dateStr={reportEndDate} setDateStr={setReportEndDate}
                                     minDateStr={reportStartDate} maxDateStr={curDate}/>
                    </div>
                </div>

                <div style={{height: 20}}/>
                <div className={classes.usageMonthlyCardContainer}>
                    {!!isListing &&
                        Array.from({length: 3}).map((_, index) =>
                           <div
                               key={index}
                               className={classes.usageMonthlyCard}
                               style={{background: "transparent", border: "none", display: "unset", padding: 0}}
                           >
                               <Skeleton borderRadius={4} height={250} width={"100%"}/>
                           </div>
                        )
                    }

                    {!isListing && reportData.length > 0 && reportData.map((data, index) =>
                        <div key={index} className={classes.usageMonthlyCard}>
                            <div className={classes.imgWrapper}>
                                {!!data.hasOwnProperty("overviewGraph") && !!data.overviewGraph &&
                                    <img className={classes.usageMonthlyCardOverViewImg} src={data.overviewGraph}
                                         alt={"Usage Report Chart"}/>
                                }


                                {!data.overviewGraph &&
                                    <div className={classes.gradientContainer}>
                                        <div className={classes.gradientBG}>
                                        </div>

                                        <span style={{marginBottom: 5}}>{data.title.split("-")[0]}</span>
                                        <span className={classes.gradientText}>{"Monthly Report"}</span>
                                    </div>

                                }


                            </div>

                            <div style={{display: "flex", flexDirection: "column", gap: 15, flex: 1, minWidth: 500}}>
                                <span className={classes.title}>{data.title}</span>
                                <span className={classes.description}>{data.summary}</span>
                                <YuJaButton
                                    style={{
                                        width: 110,
                                        height: 36,
                                        fontSize: 14,
                                        lineHeight: 1.6,
                                        whiteSpace: "nowrap"
                                    }}
                                    onClick={() => openReport(data.yearMonth)}
                                >{"View Report"}</YuJaButton>
                            </div>


                        </div>
                    )}


                    {!isListing && !reportData.length &&
                        <>
                            <div style={{flex: 1}}/>
                            <NO_RESULT style={{alignSelf: "center"}}/>
                            <div>
                                <div
                                    style={{
                                        fontWeight: "600", fontSize: 20, lineHeight: 1.4, textAlign: "center",
                                        marginTop: 20, marginBottom: 20
                                    }}
                                >No Matching Results</div>
                                <div
                                    style={{
                                        fontSize: 15, textAlign: "center",
                                    }}
                                >Try broadening your search criteria to find what you are looking for.</div>
                            </div>
                            <div style={{flex: 1}}/>
                        </>
                    }
                </div>


                {isOpen &&
                    <div
                        id={"usageReportDetailContainer"}
                        style={{
                            position: "absolute", top: 0, left: 0, width: "100%", height: "100%",
                            background: "#FFFFFF", display: "flex", flexDirection: "column", padding: 25
                        }}
                    >
                        <div className={classes.row} style={{marginBottom: 20}}>
                            <span
                                tabIndex={0}
                                style={{
                                    cursor: "pointer", display: "flex", alignItems: "center",
                                    width: "fit-content",
                                    outlineOffset: -2,
                                }}
                                onClick={() => setIsOpen(false)}
                            >
                                <BACK style={{marginRight: 2}}/>
                                <span>{"Back to Reports"}</span>
                            </span>
                            <div style={{flex: 1}}/>
                            <YuJaButton
                                onClick={() => setIsModalShown(true)}
                                style={{
                                    height: 36,
                                    fontSize: 14,
                                    lineHeight: 1.6,
                                    whiteSpace: "nowrap",
                                    marginRight: 15,
                                }}
                            ><SHARE style={{marginRight: 5}}/>{"Share"}</YuJaButton>

                            <YuJaButton
                                style={{
                                    height: 36,
                                    fontSize: 14,
                                    lineHeight: 1.6,
                                    whiteSpace: "nowrap"
                                }}
                                onClick={onDownload}
                            ><DOWNLOAD style={{marginRight: 5}}/>{"Download"}</YuJaButton>
                        </div>

                        {!isProgressing &&
                            <div
                                id={"highlightUsageTarget"}
                                style={{flex: 1, minHeight: 0, overflow: "scroll", scrollbarWidth: "none"}}
                            />
                        }


                        {isProgressing &&
                            <>
                                <div style={{alignSelf: "center", marginBottom: 50}}>
                                    <Skeleton width={80} height={36} borderRadius={8} inline={true}
                                              style={{alignSelf: "center"}}/>
                                </div>

                                <div style={{alignSelf: "center", marginBottom: 30}}>
                                    <Skeleton width={100} height={20} borderRadius={3} inline={true}
                                              style={{alignSelf: "center"}}/>
                                </div>

                                <div style={{alignSelf: "center", marginBottom: 20}}>
                                    <Skeleton width={500} height={50} borderRadius={8} inline={true}
                                              style={{alignSelf: "center"}}/>
                                </div>


                                <div style={{width: "min(90%, 900px)", alignSelf: "center", marginBottom: 20}}>
                                    <Skeleton width={"100%"} height={300} borderRadius={8} inline={true}
                                              style={{alignSelf: "center"}}/>
                                </div>
                                <div style={{width: "min(90%, 900px)", alignSelf: "center", marginBottom: 20}}>
                                    <Skeleton width={"100%"} height={300} borderRadius={8} inline={true}
                                              style={{alignSelf: "center"}}/>
                                </div>

                                <div style={{width: "min(90%, 900px)", alignSelf: "center", marginBottom: 20}}>
                                    <Skeleton width={"100%"} height={300} borderRadius={8} inline={true}
                                              style={{alignSelf: "center"}}/>
                                </div>
                            </>
                        }
                    </div>
                }
            </div>
        </div>
    );
}